import blackPink from "../../media/images/black-pink1.jpg";
import hylt from "../../media/audio/hylt.mp3";
import { ADD_PLAYLIST, ADD_TO_PLAYLIST, SELECTED_ADD_PLAYLIST } from "../types/music";

const initialState = {
  selectedAddPlaylist: null,
  favouritesMusic: [],
  playlist: [
    {
      ref: "bestof2021",
      name: "Best of 2021",
    },
    {
      ref: "newsolo",
      name: "New Solo",
    },
  ],
  playlistMusic: {
    bestof2021: {
      name: "Best of 2021",
      music: [
        {
          name: "How You Like That",
          artist: "Black Pink",
          duration: "3:28",
          img: blackPink,
          audio: hylt,
          color: "140, 30, 103",
        },
      ],
    },
    newsolo: {
      name: "New Solo",
      music: [],
    },
  },
};

const musicReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_PLAYLIST:
      return {
        ...state,
        playlist: [...state.playlist, payload],
        playlistMusic: { ...state.playlistMusic, [payload.ref]: { name: payload.name, music: [] } },
      };
    case SELECTED_ADD_PLAYLIST:
      return {
        ...state,
        selectedAddPlaylist: payload,
      };
    case ADD_TO_PLAYLIST:
      return {
        ...state,
        playlistMusic: {
          ...state.playlistMusic,
          [payload.ref]: {
            ...state.playlistMusic[payload.ref],
            music: [...state.playlistMusic[payload.ref].music, payload.music],
          },
        },
      };

    default:
      return state;
  }
};

export default musicReducer;
